import { render, staticRenderFns } from "./DobSplitTextInput.vue?vue&type=template&id=0c7c244f&scoped=true"
import script from "./DobSplitTextInput.vue?vue&type=script&lang=js"
export * from "./DobSplitTextInput.vue?vue&type=script&lang=js"
import style0 from "./DobSplitTextInput.vue?vue&type=style&index=0&id=0c7c244f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c244f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7c244f')) {
      api.createRecord('0c7c244f', component.options)
    } else {
      api.reload('0c7c244f', component.options)
    }
    module.hot.accept("./DobSplitTextInput.vue?vue&type=template&id=0c7c244f&scoped=true", function () {
      api.rerender('0c7c244f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/home/update-missing-dialog/DobSplitTextInput.vue"
export default component.exports